import DynamicFeedbackInputFields from './DynamicFeedbackFields/DynamicFeedbackInputFields';

const ParentFeedback = () => {

    const parentFields = [
        { fieldName: 'parentName', customLabelName: "Parent's Name:", type: 'text', placeholder: 'Enter Your Name' },
        { fieldName: 'studentName', customLabelName: "Student's Name:", type: 'text', placeholder: 'Enter the Student Name' },
        { fieldName: 'department', customLabelName: "Department:", type: 'text', placeholder: 'Enter the Department' },
        { fieldName: 'email', customLabelName: "Email:", type: 'email', placeholder: 'Enter Your email' },
        { fieldName: 'feedback', customLabelName: "Feedback:", type: 'textarea', placeholder: 'Enter Your Feedback' }
    ];

    return (
        <DynamicFeedbackInputFields
            title="Parent's Feedback"
            fields={parentFields}
            formType="parents"
        />
    )
}

export default ParentFeedback
